import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["price"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isNaN from 'lodash/isNaN';
import _isString from 'lodash/isString';
import _max from 'lodash/max';
import _min from 'lodash/min';
import { ZERO_PRICE_LABEL } from './ServicesListItem.constants';
import { formatCurrency } from '../../../../../../utils/currency';
import { isPriceLabel } from '../../../../../../utils/currency/currency';
import { FIRST_PRICE_DISPLAY_TYPE, RANGE_PRICE_DISPLAY_TYPE } from '../../ServicesList.constants';
export function normalizeVariationPriceTypes(variations) {
  return variations.map(function (_ref) {
    var price = _ref.price,
      rest = _objectWithoutProperties(_ref, _excluded);
    if (_isString(price)) {
      var parsedPrice = parseFloat(price);
      var isValidPrice = !_isNaN(parsedPrice);
      return _objectSpread(_objectSpread({}, rest), {}, {
        price: isValidPrice ? parsedPrice : 0
      });
    }
    return _objectSpread(_objectSpread({}, rest), {}, {
      price: price
    });
  });
}
export function getItemVariationPriceRange(item) {
  var variations = item.variations;
  var normalizedPriceVariations = normalizeVariationPriceTypes(variations);
  var prices = normalizedPriceVariations.map(function (_ref2) {
    var price = _ref2.price;
    return price;
  });
  if (prices.length === 0) {
    return [0, 0];
  }
  if (prices.length === 1) {
    return [prices[0], null];
  }
  return [_min(prices), _max(prices)];
}
export function isUsingPriceLabel(item) {
  var variations = item.variations;
  return variations.some(function (_ref3) {
    var price = _ref3.price;
    return isPriceLabel(price);
  });
}
export function getPriceLabel(item) {
  var variations = item.variations;
  return variations.map(function (_ref4) {
    var price = _ref4.price;
    return price;
  }).join(' | ');
}
export function getRangePriceLabel(priceDisplayType, minPrice, maxPrice) {
  var _ref5 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref5$precision = _ref5.precision,
    precision = _ref5$precision === void 0 ? 2 : _ref5$precision,
    _ref5$displayZeroCost = _ref5.displayZeroCostItemPrices,
    displayZeroCostItemPrices = _ref5$displayZeroCost === void 0 ? false : _ref5$displayZeroCost;
  if (priceDisplayType === FIRST_PRICE_DISPLAY_TYPE && maxPrice) {
    return "".concat(formatCurrency(minPrice, precision), "+");
  }
  if (priceDisplayType === RANGE_PRICE_DISPLAY_TYPE && maxPrice) {
    return "".concat(formatCurrency(minPrice, precision), " - ").concat(formatCurrency(maxPrice, precision));
  }
  if (minPrice === 0 && maxPrice === 0) {
    return '-';
  }
  var priceLabel = formatCurrency(minPrice, precision);
  var isZeroPrice = priceLabel === ZERO_PRICE_LABEL;
  var displayLabel = displayZeroCostItemPrices || !displayZeroCostItemPrices && !isZeroPrice;
  return displayLabel ? priceLabel : '';
}